/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCOUNTRY = {
    Afghanistan: 'AF',
    AlandIslands: 'AX',
    Albania: 'AL',
    Algeria: 'DZ',
    AmericanSamoa: 'AS',
    Andorra: 'AD',
    Angola: 'AO',
    Anguilla: 'AI',
    Antarctica: 'AQ',
    AntiguaAndBarbuda: 'AG',
    Argentina: 'AR',
    Armenia: 'AM',
    Aruba: 'AW',
    Australia: 'AU',
    Austria: 'AT',
    Azerbaijan: 'AZ',
    Bahamas: 'BS',
    Bahrain: 'BH',
    Bangladesh: 'BD',
    Barbados: 'BB',
    Belarus: 'BY',
    Belgium: 'BE',
    Belize: 'BZ',
    Benin: 'BJ',
    Bermuda: 'BM',
    Bhutan: 'BT',
    Bolivia: 'BO',
    BonaireSintEustatiusAndSaba: 'BQ',
    BosniaAndHerzegovina: 'BA',
    Botswana: 'BW',
    BouvetIsland: 'BV',
    Brazil: 'BR',
    BritishIndianOceanTerritory: 'IO',
    BruneiDarussalam: 'BN',
    Bulgaria: 'BG',
    BurkinaFaso: 'BF',
    Burundi: 'BI',
    CaboVerde: 'CV',
    Cambodia: 'KH',
    Cameroon: 'CM',
    Canada: 'CA',
    CaymanIslands: 'KY',
    CentralAfricanRepublic: 'CF',
    Chad: 'TD',
    Chile: 'CL',
    China: 'CN',
    ChristmasIsland: 'CX',
    CocosKeelingIslands: 'CC',
    Colombia: 'CO',
    Comoros: 'KM',
    CongoBrazzaville: 'CG',
    CongoDemocraticRepublic: 'CD',
    CookIslands: 'CK',
    CostaRica: 'CR',
    CteDIvoireIvoryCoast: 'CI',
    CroatiaLocalNameHrvatska: 'HR',
    Cuba: 'CU',
    Curaao: 'CW',
    Cyprus: 'CY',
    CzechiaCzechRepublic: 'CZ',
    Denmark: 'DK',
    Djibouti: 'DJ',
    Dominica: 'DM',
    DominicanRepublic: 'DO',
    Ecuador: 'EC',
    Egypt: 'EG',
    ElSalvador: 'SV',
    EquatorialGuinea: 'GQ',
    Eritrea: 'ER',
    Estonia: 'EE',
    EswatiniPreviouslySwaziland: 'SZ',
    Ethiopia: 'ET',
    FalklandIslandsMalvinas: 'FK',
    FaroeIslands: 'FO',
    Fiji: 'FJ',
    Finland: 'FI',
    France: 'FR',
    FrenchGuiana: 'GF',
    FrenchPolynesia: 'PF',
    FrenchSouthernTerritories: 'TF',
    Gabon: 'GA',
    Gambia: 'GM',
    Georgia: 'GE',
    Germany: 'DE',
    Ghana: 'GH',
    Gibraltar: 'GI',
    Greece: 'GR',
    Greenland: 'GL',
    Grenada: 'GD',
    Guadeloupe: 'GP',
    Guam: 'GU',
    Guatemala: 'GT',
    Guernsey: 'GG',
    Guinea: 'GN',
    GuineaBissau: 'GW',
    Guyana: 'GY',
    Haiti: 'HT',
    HeardAndMcDonaldIslands: 'HM',
    HolySeeVaticanCityState: 'VA',
    Honduras: 'HN',
    HongKong: 'HK',
    Hungary: 'HU',
    Iceland: 'IS',
    India: 'IN',
    Indonesia: 'ID',
    IranIslamicRepublic: 'IR',
    Iraq: 'IQ',
    Ireland: 'IE',
    IsleOfMan: 'IM',
    Israel: 'IL',
    Italy: 'IT',
    Jamaica: 'JM',
    Japan: 'JP',
    Jersey: 'JE',
    Jordan: 'JO',
    Kazakhstan: 'KZ',
    Kenya: 'KE',
    Kiribati: 'KI',
    KoreaNorthDemocraticPeoplesRepublic: 'KP',
    KoreaSouthRepublic: 'KR',
    Kuwait: 'KW',
    Kyrgyzstan: 'KG',
    Laos: 'LA',
    Latvia: 'LV',
    Lebanon: 'LB',
    Lesotho: 'LS',
    Liberia: 'LR',
    LibyanArabJamahiriya: 'LY',
    Liechtenstein: 'LI',
    Lithuania: 'LT',
    Luxembourg: 'LU',
    Macao: 'MO',
    MacedoniaFormerYugoslavia: 'MK',
    Madagascar: 'MG',
    Malawi: 'MW',
    Malaysia: 'MY',
    Maldives: 'MV',
    Mali: 'ML',
    Malta: 'MT',
    MarshallIslands: 'MH',
    Martinique: 'MQ',
    Mauritania: 'MR',
    Mauritius: 'MU',
    Mayotte: 'YT',
    Mexico: 'MX',
    MicronesiaFederatedStates: 'FM',
    MoldovaRepublic: 'MD',
    Monaco: 'MC',
    Mongolia: 'MN',
    Montenegro: 'ME',
    Montserrat: 'MS',
    Morocco: 'MA',
    Mozambique: 'MZ',
    MyanmarBurma: 'MM',
    Namibia: 'NA',
    Nauru: 'NR',
    Nepal: 'NP',
    Netherlands: 'NL',
    NewCaledonia: 'NC',
    NewZealand: 'NZ',
    Nicaragua: 'NI',
    Niger: 'NE',
    Nigeria: 'NG',
    Niue: 'NU',
    NorfolkIsland: 'NF',
    NorthernMarianaIslands: 'MP',
    Norway: 'NO',
    Oman: 'OM',
    Pakistan: 'PK',
    Palau: 'PW',
    Panama: 'PA',
    PapuaNewGuinea: 'PG',
    Paraguay: 'PY',
    Peru: 'PE',
    Philippines: 'PH',
    Pitcairn: 'PN',
    Poland: 'PL',
    Portugal: 'PT',
    PuertoRico: 'PR',
    Qatar: 'QA',
    Reunion: 'RE',
    Romania: 'RO',
    RussianFederation: 'RU',
    Rwanda: 'RW',
    SaintBarthlemy: 'BL',
    SaintHelenaAscensionAndTristanDaCunha: 'SH',
    SaintKittsAndNevis: 'KN',
    SaintLucia: 'LC',
    SaintMartinFrenchPart: 'MF',
    SaintPierreAndMiquelon: 'PM',
    SaintVincentAndTheGrenadines: 'VC',
    Samoa: 'WS',
    SanMarino: 'SM',
    SaoTomeAndPrincipe: 'ST',
    SaudiArabia: 'SA',
    Senegal: 'SN',
    Serbia: 'RS',
    Seychelles: 'SC',
    SierraLeone: 'SL',
    Singapore: 'SG',
    SintMaartenDutchPart: 'SX',
    SlovakiaSlovakRepublic: 'SK',
    Slovenia: 'SI',
    SolomonIslands: 'SB',
    Somalia: 'SO',
    SouthAfrica: 'ZA',
    SouthGeorgiaAndTheSouthSandwichIslands: 'GS',
    SouthSudan: 'SS',
    Spain: 'ES',
    SriLanka: 'LK',
    Sudan: 'SD',
    Suriname: 'SR',
    SvalbardAndJanMayenIslands: 'SJ',
    Sweden: 'SE',
    Switzerland: 'CH',
    SyriaArabRepublic: 'SY',
    TaiwanProvinceOfChina: 'TW',
    Tajikistan: 'TJ',
    TanzaniaUnitedRepublic: 'TZ',
    Thailand: 'TH',
    TimorLeste: 'TL',
    Togo: 'TG',
    Tokelau: 'TK',
    Tonga: 'TO',
    TrinidadAndTobago: 'TT',
    Tunisia: 'TN',
    Turkey: 'TR',
    Turkmenistan: 'TM',
    TurksAndCaicosIslands: 'TC',
    Tuvalu: 'TV',
    Uganda: 'UG',
    Ukraine: 'UA',
    UnitedArabEmirates: 'AE',
    UnitedKingdom: 'GB',
    UnitedStatesMinorOutlyingIslands: 'UM',
    UnitedStatesOfAmerica: 'US',
    Uruguay: 'UY',
    Uzbekistan: 'UZ',
    Vanuatu: 'VU',
    Venezuela: 'VE',
    VietNam: 'VN',
    VirginIslandsBritish: 'VG',
    VirginIslandsUs: 'VI',
    WallisAndFutunaIslands: 'WF',
    WestBankAndGazaStateOfPalestine: 'PS',
    WesternSahara: 'EH',
    Yemen: 'YE',
    Zambia: 'ZM',
    Zimbabwe: 'ZW'
} as const;
export type IAPCOUNTRY = typeof IAPCOUNTRY[keyof typeof IAPCOUNTRY];


export function IAPCOUNTRYFromJSON(json: any): IAPCOUNTRY {
    return IAPCOUNTRYFromJSONTyped(json, false);
}

export function IAPCOUNTRYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCOUNTRY {
    return json as IAPCOUNTRY;
}

export function IAPCOUNTRYToJSON(value?: IAPCOUNTRY | null): any {
    return value as any;
}

